import { createFileRoute } from "@tanstack/react-router";
import { OAuthConsentPage, oauthConsentRoute } from "@/features/account-access";

export const Route = createFileRoute("/oauth/consent")({
    ssr: oauthConsentRoute.ssr,
    head: oauthConsentRoute.head,
    component: OAuthConsentPage,
});
